module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "m-secItem"
  }, [_vm._t("default", [_vm._v("メニューがありません")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-007ebbb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SecItem.vue
// module id = 1274
// module chunks = 0